export interface VuetifyInputsSettings {
  defaultVariant?: 'outlined' | 'plain' | 'underlined' | 'filled' | 'solo' | 'solo-inverted' | 'solo-filled',
}

export const vuetifyInputsSettingsKey = Symbol('vuetifyInputsSettingsKey');
